export const contractType = ["ERC721", "ERC20", "ERC1155", "Custom"];
export const conditionChains = [
  "Ethereum",
  "Polygon",
  "Fantom",
  "FantomTest",
  "AVAX",
  "Fuji",
  "BSC",
  "BSCTest",
  "Optimism",
  "OptimismGoerli",
  "OptimismKovan",
  "FVM",
  "Calibration",
  "shardeum",
  "Shardeum_Lib1",
  "Shardeum_Lib2",
  "Shardeum_Sphinx",
"Destra",
  "Destra_Testnet"
];

export const coreumParameters = {
  methords: ['getNftsByAddress', 'getFtsByAddress']
}
export const radixParameters = {
  methords: ['getNftsByAddress', 'getFtsByAddress']
}

export const comparators = ["<", ">", "<=", ">=", "=="];
